exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown__button-text {\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* dropdown-item-extended */\n.dropdown-item-extended button {\n  text-align: left;\n  padding: 8px 15px;\n  color: #40a3d5;\n}\n\n.dropdown-item-extended button .headline {\n  font-size: 14px;\n}\n\n.dropdown-item-extended button .note {\n  font-size: 12px;\n}\n\n.inlet-wrapp .csas-selectbox .csas-option-wrapper ol li a.disabled {\n  background-color: #e9eff4;\n  color: #aabacc;\n}\n\n@media (max-width: 768px) {\n  .dropdown-item-extended button .note {\n    word-wrap: normal;\n    text-align: left;\n  }\n}\n", ""]);

// exports
